<template>
    <div>
        <section class="m_info"><!-- 音楽情報 -->
            <div class="cart_tit">{{ characters.cart }}</div>

            <div class="cart_subtit">{{ characters.purchase_items }}</div>

            <div>
                <!-- 1アイテム -->
                <div v-for="(item, index) in cart" class="cart_box_par">
                    <div class="cart_box">
                        <div class="cb_item1"><img :src="'/item/image/'+item.item_id" alt="" width="100%"></div>
                        <div class="cb_item2">
                            <div class="cb_txt1" v-if="item_type_view_status == 1">{{ item.type_op + ' ' + item.on_sale_year }}</div>
                            <div class="cb_txt2">{{ item.title }}</div>
                            <div class="cb_txt3"></div>
                        </div>
                        <div class="cb_item3">
                            <div class="cb_item3_inner">
                                <p v-if="item.soldout_flag==0">{{ '￥' + item.price.toLocaleString() }}</p>
                                <p v-if="item.soldout_flag==1">{{ characters.soldout }}</p>
                            </div>
                            <div class="cb_item3_inner" v-if="item.type=='goods'"><input v-bind:disabled="wait_flag" @change="resetSumNumber(index, $event)" :value="item.num" type="number" min="1" :max="otanishinjiro_access_status!=1?10:''"></div>
                            <div class="cb_item3_inner" @click="removeItem(index)"><p class="screen-transition">{{ characters.remove }}</p></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="subtotal">
                <p v-if="otanishinjiro_access_status==0">{{ characters.subtotal }}({{ sum_num }}{{ characters.item_number }}) {{ '￥' + sum_yen.toLocaleString() }}({{ characters.tax_included }})</p>
                <p v-if="otanishinjiro_access_status==1">{{ '￥' + sum_yen.toLocaleString() }}</p>
            </div>

            <div class="confirm" v-if="(0<cart.length)"><button type="submit" @click="jumpPurchaseConfirm()">{{ characters.open_cart_confirm_page }}</button></div>

            <div class="to_store"><a href="/store">{{ characters.back_to_store }}</a></div>

        </section>
    </div>
</template>

<script>
    export default {
        name: "cart-confirm",
        props: ['item_type_view_status', 'otanishinjiro_access_status', 'json_characters'],
        data: function () {
            return {
                cart: [],
                sum_yen: 0,
                soldout_flag: false,
                characters: Object,
                sum_num: 0,
                wait_flag: false,
            }
        },
        mounted() {
            axios.default
                .get('/cart/get')
                .then(response => {
                    this.cart = response.data;
                    for(let item in this.cart) {
                        if(this.cart[item].zero_flag == 1) {
                            this.cart[item].price = 0;
                        } else {
                            this.sum_yen += this.cart[item].price*this.cart[item].num;
                        }
                        this.sum_num += this.cart[item].num;
                        if(this.cart[item].soldout_flag == 1) {
                            this.soldout_flag = true;
                        }
                    }
                });
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            jumpPurchaseConfirm() {
                if(this.soldout_flag) {
                    alert(this.characters.remove_soldout_items);
                } else {
                    location.href='/purchase/confirm';
                }
            },
            removeItem: function (index) {
                location.href='/cart/remove/'+index;
            },
            resetSumNumber: function(index, event) {
                this.wait_flag = true;
                let before_num = this.cart[index]['num'];
                this.cart[index]['num']=event.target.value;
                axios.default
                    .post('/cart/change/number', {index:index, new_number:event.target.value})
                    .then(response => {
                        if(response.data.err) {
                            alert(this.characters[response.data.err]);
                            this.cart[index]['num'] = before_num;
                            this.wait_flag = false;
                            return;
                        }
                        this.cart = response.data;
                        this.sum_yen = 0;
                        this.sum_num = 0;
                        for(let item in this.cart) {
                            this.sum_yen += this.cart[item].price*this.cart[item].num;
                            this.sum_num += this.cart[item].num;
                        }
                        this.wait_flag = false;
                    });
            }
        },
    }
</script>

<style scoped>
</style>
